import type { AppCopy } from '../catalogs';

export const roAppCopy = {
  welcomeHeading: 'Cum te pot ajuta azi?',
  thinking: 'Gândirea',
  scrollToBottom: 'Derulați în jos',
  reasoning: 'Raționamentul',
  reasoningInProgress: 'în curs',
  citationPages: 'Paginile {first}–{last}',
  citationTitle: 'Extras din sursă',
  citationLoading: 'Se încarcă sursa…',
  citationUnavailable: 'Textul citat nu este disponibil sau nu mai aveți acces.',
  citationOpen: 'Deschide sursa',
  citationCopied: 'Referință copiată',
  copy: 'Copiere',
  more: 'Mai mult',
  tryAgain: 'Încercați din nou',
  answerTruncated: 'Răspunsul a atins limita de lungime și a fost întrerupt.',
  continueAnswer: 'Continuă răspunsul',
  exportMarkdown: 'Exportați ca Markdown',
  edit: 'Editați',
  cancel: 'Anulează',
  update: 'Actualizare',
  previous: 'Anterior',
  next: 'În continuare',
  messagePlaceholder: 'Trimite un mesaj…',
  projectHomePlaceholder: 'Chat nou în {project}',
  sharedChatEveryone: 'Toată lumea de la {company} poate citi acest chat',
  sharedChatOnePerson: '1 persoană poate citi acest chat',
  sharedChatPeople: 'Numărul de persoane care pot citi acest chat: {count}',
  forkedChatPlaceholder: 'Continuați cu propriile conexiuni…',
  newAnswer: 'Răspuns nou',
  messageInput: 'Introducerea mesajului',
  sendMessage: 'Trimite mesaj',
  stopGenerating: 'Nu mai generați',
  addAttachment: 'Adăugați atașament',
  removeFile: 'Eliminați fișierul',
  attachmentPreview: 'Previzualizare atașament',
  imageAttachmentPreview: 'Previzualizare imagine atașată',
  image: 'Imagine',
  openLink: 'link deschis',
  document: 'Document',
  file: 'Fișier',
  attachment: 'atașament',
  uploadFailed: 'încărcarea a eșuat',
  uploading: 'încărcare',
  toolIncomplete: 'Incomplet',
  toolActivity: 'Activitate',
  activityThinking: 'Se gândește…',
  activityWriting: 'Scrie…',
  activityWaiting: 'Se așteaptă aprobarea ta',
  activityStopped: 'Oprit',
  activityCouldNotFinish: 'Nu s-a putut finaliza',
  activitySources: 'surse',
  activityShowThinking: 'Arată gândirea',
  activityOpen: 'Deschide activitatea',
  activitySteps: 'Pași',
  activitySourcesTab: 'Surse',
  activityUnavailable: 'Această activitate nu este disponibilă.',
  activityInput: 'Intrare',
  activityOutput: 'Ieșire',
  activityNoSources: 'Răspunsul nu a citat surse.',
  activityApprovedByReply: 'Aprobat prin răspunsul tău',

  toolRunning: 'În curs',
  toolComplete: 'Finalizat',
  toolNeedsApproval: 'Necesită aprobare',
  toolInput: 'Date de intrare',
  toolCall: 'apel de instrument',
  toolCalls: 'apeluri de instrumente',
  openMenu: 'Deschide meniul',
  closeMenu: 'Închide meniul',
  close: 'Închide',
  showInTextField: 'Afișează în câmpul de text',
  settings: 'Setări',
  appearance: 'Aspect',
  themeLight: 'Luminos',
  themeDark: 'Întunecat',
  themeSystem: 'Sistem',
  themeChoiceHelp:
    'Se aplică pe toate dispozitivele tale. „Sistem” urmează modul luminos sau întunecat al fiecărui dispozitiv.',
  themeSaveFailed: 'Nu am putut salva aspectul, așa că a rămas neschimbat. Încearcă din nou.',
  toolUsed: 'Instrument folosit',
  toolCancelled: 'Instrument anulat',
  toolResult: 'Rezultat:',
  toolError: 'Eroare:',
  toolCancelledReason: 'Motivul anulat:',
  approvalAllow: 'Permite',
  approvalAlwaysAllow: 'Permite întotdeauna',
  approvalDeny: 'Refuzați',
  approvalAlwaysDeny: 'Refuzați întotdeauna',
  approvalConfirm: 'Confirmați',
  approvalBack: 'Înapoi',
  approvalApprovedResult: 'Aprobat de utilizator',
  approvalDeniedResult: 'Utilizatorul a refuzat executarea instrumentului',
  logout: 'Deconectați-vă',
  loginOrCreateAccount: 'Autentificare/Creează cont',
  newChat: 'Chat nou',
  untitledChat: 'Chat fără titlu',
  previousChats: 'Chaturile anterioare',
  openChat: 'Deschideți chatul {title}',
  moreActionsForChat: 'Mai multe acțiuni pentru {title}',
  chatActions: 'Acțiuni de chat',
  closeChatActions: 'Închideți acțiunile de chat',
  deleteChatQuestion: 'Ștergeți chatul?',
  deleteChatDescription: 'Chatul „{title}” va fi șters definitiv.',
  deleteChat: 'Șterge chatul',
  keepChat: 'Păstrați conversația',
  delete: 'Ștergeți',
  deleting: 'Se șterge…',
  chatDeleteFailed: 'Chatul nu a putut fi șters. Încearcă din nou.',
  settingsDescription: 'Personalizați modul în care funcționează asistentul pentru dvs.',
  settingsDesktopDescription: 'Personalizați modul în care vă răspunde asistentul.',
  personalization: 'Personalizare',
  personalizationDescription:
    'Personalizați instrucțiunile pe care asistentul le urmează în fiecare răspuns.',
  languageAndRegion: 'Limba și regiunea',
  languageAndRegionDescription: 'Alegeți limba și fusul orar.',
  memories: 'Amintiri',
  memoriesDescription:
    'Vizualizați, editați sau ștergeți ceea ce asistentul își amintește despre dvs.',
  account: 'Cont',
  accountDescription: 'Gestionați contul și ștergerea definitivă a datelor dvs.',
  backToSettings: 'Înapoi la setări',
  closeSettings: 'Închideți setările',
  settingsCategories: 'Categoriile de setări',
  yourSettings: 'Setările dvs',
  dataAndAccount: 'Date și cont',
  viewAndManageMemories: 'Vizualizați și gestionați ceea ce își amintește asistentul',
  loginToUseMemories: 'Conectați-vă pentru a utiliza amintiri',
  manageOrDeleteAccount: 'Gestionați sau ștergeți contul',
  unsavedChanges: 'Aveți modificări nesalvate',
  unsavedCloseDescription: 'Închiderea setărilor va elimina modificările de pe această pagină.',
  unsavedBackDescription:
    'Dacă reveniți înapoi, modificările de pe această pagină vor fi eliminate.',
  continueEditing: 'Continuați editarea',
  discardChanges: 'Renunțați la modificări',
  saveChanges: 'Salvați modificările',
  localSettingsNote: 'Salvat în acest browser. Conectați-vă pentru a salva în contul dvs.',
  personality: 'Personalitate',
  personalityHelp: 'Instrucțiuni personalizate pe care asistentul le urmează în fiecare răspuns',
  personalityPlaceholder:
    'De exemplu: Fii concis și concret. Locuiesc în Göteborg și îmi place mâncarea vegetariană.',
  timezone: 'Fus orar',
  searchTimezone: 'Căutați fusuri orare...',
  automaticBrowser: 'automat (browser)',
  saved: 'Salvat {date}',
  addMemory: 'Adăugați o amintire',
  newMemory: 'Amintire nouă',
  memoryPlaceholder: 'De exemplu: Prefer răspunsuri scurte și concrete.',
  editMemory: 'Editați amintirea',
  saveMemory: 'Salvați amintirea',
  deleteMemory: 'Ștergeți amintirea',
  memorySaveFailed: 'Memoria nu a putut fi salvată. Încearcă din nou.',
  memoryLimitReached: 'Puteți salva până la 50 de amintiri. Ștergeți una înainte de a adăuga alta.',
  memoryInvalid: 'Amintirile nu pot conține linkuri. Eliminați linkul și încercați din nou.',
  memoryDeleteFailed: 'Memoria nu a putut fi ștearsă. Încearcă din nou.',
  memoryLoadFailed: 'Amintirile nu au putut fi încărcate.',
  loadingMemories: 'Se încarcă amintirile…',
  emptyMemories:
    'Asistentul salvează amintiri despre tine în timp ce vorbești — ce îți place, unde locuiești și ce faci. Le puteți vizualiza, edita și șterge aici.',
  deleteAccountHelp:
    'Ștergeți permanent contul și toate chaturile, amintirile și setările asociate.',
  deleteAccount: 'Ștergeți contul',
  deleteAccountQuestion: 'Ștergeți definitiv contul?',
  deleteAccountDescription:
    'Toate chaturile, mesajele, amintirile, setările și acreditările de conectare vor fi șterse. Această acțiune nu poate fi anulată.',
  deleteAccountConfirm: 'Da, ștergeți contul meu',
  accountDeleteFailed: 'Contul nu a putut fi șters. Nu a fost eliminat nimic — încercați din nou.',
  logoutEverywhereTitle: 'Toate dispozitivele',
  logoutEverywhereHelp:
    'Deconectați-vă de pe toate dispozitivele și browserele în care contul dumneavoastră este deschis, inclusiv de pe acesta.',
  logoutEverywhere: 'Deconectare peste tot',
  logoutEverywhereQuestion: 'Vă deconectați de pe toate dispozitivele?',
  logoutEverywhereDescription:
    'Va trebui să vă conectați din nou pe toate dispozitivele și browserele, inclusiv pe acesta. Conversațiile și setările dumneavoastră rămân neschimbate.',
  loggingOut: 'Se deconectează…',
  logoutEverywhereFailed:
    'Nu am putut confirma că ați fost deconectat peste tot. Încercați din nou sau verificați pe alt dispozitiv dacă sunteți încă conectat.',
  settingsSaveFailed: 'Setările nu au putut fi salvate. Încearcă din nou.',
  customInstructions: 'Instrucțiuni personalizate',
  notSet: 'Nu setat',
  automaticLanguage: 'Limbă automată',
  automaticTimezone: 'fus orar automat',
  appLanguage: 'Limba aplicației',
  appLanguageHelp:
    'Controlează întreaga interfață a aplicației și datele. Răspunsurile asistentului continuă să urmeze limba în care scrieți.',
  automaticBrowserLanguage: 'Automat (limba browserului)',
  previousLanguageChoice: 'Alegerea anterioară: {language} ({locale})',
  previousLanguageChoiceCode: 'Alegerea anterioară ({locale})',
  canvasCopyLink: 'Copiază linkul',
  canvasLinkCopied: 'Linkul a fost copiat',
  actionUpdatedWithEdits: 'Actualizat cu modificările dvs.',
  activityStepsDone: 'one:pas finalizat|few:pași finalizați|other:de pași finalizați',
  activityResultsCount: 'one:rezultat|few:rezultate|other:de rezultate',
  canvasCopyLinkFailed: 'Linkul nu a putut fi copiat',
  canvasOpenInAgent: 'Deschide în {agent}',
  canvasExpand: 'Extinde',
  canvasExitFullView: 'Ieși din vizualizarea completă',
  webSourceUnread:
    'Legat în acest răspuns. Poneva nu a citit această pagină, așa că nu există nimic de afișat aici.',
  webSourceOpenOriginal: 'Deschide originalul',
  toolProgressSettings: 'Se modifică setările dvs.…',
  toolProgressAgent: 'Se creează agentul…',
  toolProgressConnections: 'Se caută opțiunile de conectare…',
  toolProgressResult: 'Se pregătește rezultatul dvs.…',
  toolProgressClarification: 'Se pregătește o clarificare…',
  toolProgressKnowledge: 'Se pregătește o actualizare sugerată a cunoștințelor…',
  toolProgressQuestion: 'Se pregătește o întrebare pentru dvs.…',
  toolProgressSkill: 'Se conturează Skill-ul…',
  toolErrorSettings: 'Setările dvs. nu au fost modificate.',
  toolErrorAgent: 'Agentul nu a putut fi creat.',
  toolErrorConnections: 'Opțiunile de conectare nu au putut fi încărcate.',
  toolErrorResult: 'Rezultatul nu a fost salvat.',
  toolErrorClarification: 'Clarificarea nu a putut fi pregătită.',
  toolErrorKnowledge: 'Actualizarea sugerată a cunoștințelor nu a putut fi pregătită.',
  toolErrorQuestion: 'Întrebarea nu a putut fi pregătită.',
  toolErrorSkill: 'Ciorna Skill-ului nu a putut fi salvată.',
  toolErrorOpenSettings: 'Deschide Setări',
  toolErrorOpenAgents: 'Deschide Agenți',
  toolErrorOpenConnections: 'Deschide Conexiuni',
  toolStepIncomplete: 'Acest pas nu a fost finalizat.',
  toolEarlierAttemptsFailed:
    'one:încercare anterioară nu a reușit|few:încercări anterioare nu au reușit|other:de încercări anterioare nu au reușit',
} satisfies AppCopy;
